import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

import { ref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XCommonDialog',
  props: {
    title: {},
    width: {},
    className: {}
  },
  emits: ['close', 'open'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var emits = __emit;
    var visible = ref(false);
    watch(visible, function () {
      if (!visible.value) {
        emits('close');
      }
    });
    function open(data) {
      visible.value = true;
      emits('open', data);
    }
    function close() {
      visible.value = false;
    }
    __expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: _normalizeClass(_ctx.className),
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(visible) ? visible.value = $event : null;
        }),
        title: _ctx.title,
        width: _ctx.width,
        onClose: close
      }, {
        footer: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "footer")];
        }),
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["class", "modelValue", "title", "width"]);
    };
  }
});